import type {
    INCoreUIKitIconProps
} from "../../../types";
import {
    Path,
    Mask,
    Svg,
    G
} from "react-native-svg";

const stylesheet = {
    mask: {
        maskType: "luminance" as const
    }
};

const EnUsIcon = ({
    size = 32,
    style,
    ...props
}: INCoreUIKitIconProps) => {
    const pathScale = 32 / size;

    return <Svg
        height={size}
        width={size}
        style={{
            ...style
        }}
        {...props}
    >
        <Mask
            maskUnits="userSpaceOnUse"
            style={stylesheet.mask}
            height={32}
            width={32}
            id="a"
            x={0}
            y={0}
        >
            <Path
                d="M16 32c8.837 0 16-7.163 16-16S24.837 0 16 0 0 7.163 0 16s7.163 16 16 16Z"
                transform={[
                    {
                        scale: 1 / pathScale
                    }
                ]}
                fill="#fff"
            />
        </Mask>
        <G
            mask="url(#a)"
        >
            <Path
                d="M16 0h16v4l-2 2 2 2v4l-2 2 2 2v4l-2 2 2 2v4l-16 2-16-2v-4l2-2-2-2v-4L16 0Z"
                transform={[
                    {
                        scale: 1 / pathScale
                    }
                ]}
                fill="#EEE"
            />
            <Path
                d="M14 4h18v4H14V4Zm0 8h18v4H16l-2-4ZM0 20h32v4H0v-4Zm0 8h32v4H0v-4Z"
                transform={[
                    {
                        scale: 1 / pathScale
                    }
                ]}
                fill="#D80027"
            />
            <Path
                transform={[
                    {
                        scale: 1 / pathScale
                    }
                ]}
                d="M0 0h16v16H0V0Z"
                fill="#0052B4"
            />
            <Path
                d="m11.688 15.188 3.562-2.563h-4.375l3.563 2.563L13.062 11l-1.374 4.188Zm-5.063 0 3.563-2.563H5.811l3.563 2.563L8 11l-1.375 4.188Zm-5.063 0 3.563-2.563H.75l3.563 2.563L2.938 11l-1.376 4.188Zm10.126-5.063 3.562-2.563h-4.375l3.563 2.563-1.376-4.188-1.374 4.188Zm-5.063 0 3.563-2.563H5.811l3.563 2.563L8 5.937l-1.375 4.188Zm-5.063 0 3.563-2.563H.75l3.563 2.563-1.375-4.188-1.376 4.188ZM11.688 5l3.562-2.563h-4.375L14.438 5 13.062.812 11.688 5ZM6.625 5l3.563-2.563H5.811L9.376 5 8 .812 6.625 5ZM1.562 5l3.563-2.563H.75L4.313 5 2.938.812 1.562 5Z"
                transform={[
                    {
                        scale: 1 / pathScale
                    }
                ]}
                fill="#EEE"
            />
        </G>
    </Svg>;
};
export default EnUsIcon;
